// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages-pricing-style----features-module---container---38hP_ bg-white paddingLeftRight-0 breakPointS-paddingLeftRight-l breakPointM-paddingLeftRight-xl","item":"src-pages-pricing-style----features-module---item---1TCOE display-flex flexDirection-column breakPointM-flexDirection-row alignItems-center"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/pricing/style/features.module.css
// module id = 756
// module chunks = 18116671869107 159537844214909